import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as DialogCreators } from "modules/dialog/model"
import { getUIConstraints, getApplyButtonEnabled, getApplyExposureButtonEnabled, getApplySettingsButtonEnabled, getFactors, getComputedConstraints, getFactorsErrors, getConstraintsErrors, getNumberOfCurrentConstraints, getNumberOfCurrentExposure, getComputedSettings, getSettings } from "./selectors/constraints"
import { getFactorsSearchResults, getFactorsSearchValue, getFactorsSearchVisible } from "./selectors/factor-targets"
import { getForecasts, getSelectedForecast } from "./selectors"
import { FORECAST_LIST_QUERY } from "resources/forecasts"

export default createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
  }),
  required: ["account"],
  data: [{
    ...FORECAST_LIST_QUERY,
    as: null,
  }],
  mapStateToProps: (state, props) => ({
    uiConstraints: getUIConstraints(state, props),
    computedConstraints: getComputedConstraints(state, props),
    computedSettings: getComputedSettings(state, props),
    settings: getSettings(state, props),
    forecasts: getForecasts(state, props),
    selectedForecast: getSelectedForecast(state, props),
    applyButtonEnabled: getApplyButtonEnabled(state, props),
    applyExposureButtonEnabled: getApplyExposureButtonEnabled(state, props),
    applySettingsButtonEnabled: getApplySettingsButtonEnabled(state, props),
    factorsSearchResults: getFactorsSearchResults(state, props),
    factorsSearchValue: getFactorsSearchValue(state),
    factorsSearchVisible: getFactorsSearchVisible(state),
    factors: getFactors(state, props),
    factorsErrors: getFactorsErrors(state, props),
    constraintsErrors: getConstraintsErrors(state, props),
    numberOfCurrentConstraints: getNumberOfCurrentConstraints(state, props),
    numberOfCurrentExposure: getNumberOfCurrentExposure(state, props),
  }),
  actions: {
    ...Creators,
    openDialog: DialogCreators.open,
  },
})
